module.exports = __webpack_public_path__ + "img/show-content.a2ea4f39.svg";